import React from 'react'
import './RightBar.scss'
import { useSelector, useDispatch } from 'react-redux';
import { rightBarClicked } from '../redux/actions/index';
// import { rightBarClicked, chatBarClicked, todoBarClicked } from '../redux/actions/index';
import { ReactComponent as RightwardIcon } from "../assets/svg/rightBar/rightward.svg";

function RightBar() {
    const rightTab = useSelector(state => state.rightTab)
    const dispatch = useDispatch()
    const rightBarClickeD = () => {
        dispatch(rightBarClicked());
    }
    // const chatBarClickeD = () => {
    //     dispatch(chatBarClicked());
    // }
    // const todoBarClickeD = () => {
    //     dispatch(todoBarClicked());
    // }
    return (
        <div className={rightTab?.flag ? 'RightBar' : 'RightBar rightBar-hide'}>
            <RightwardIcon className={ rightTab?.flag ? 'rightBarIcon' : 'rightBarIcon rotate-back'} onClick={rightBarClickeD}/>
            <div className={rightTab?.flag ? 'hidden':'number-in-round'}>
                {rightTab?.todoTab?.count + rightTab?.notficheTab?.count + rightTab?.chatTab?.count}
            </div>
            <div className={ rightTab?.flag ? '' : 'hidden'}>
                <div className='section'>
                    <div className='number-in-round'>{rightTab?.todoTab?.count}</div>
                    <p>ToDo</p>
                    <div className='right'>
                        <p>13</p>
                        <RightwardIcon className='rotate-clockwise'/>
                    </div>
                </div>
                <div className='inter-line'></div>
                <div className='section'>
                    <div className='number-in-round'>{rightTab?.notficheTab?.count}</div>
                    <p>Notfiche</p>
                    <div className='right'>
                        <p>13</p>
                        <RightwardIcon className='rotate-clockwise'/>
                    </div>
                </div>
                <div className='inter-line'></div>
                <div className='section'>
                    <div className='number-in-round'>{rightTab?.chatTab?.count}</div>
                    <p>Chat</p>
                    <div className='right'>
                        <p>13</p>
                        <RightwardIcon className='rotate-clockwise'/>
                    </div>
                </div>
                <div className='inter-line'></div>
            </div>
        </div>
    )
}

export default RightBar